import { AGENT_RUN_PARAM } from '../config'

export function getAgentRunUrl(documentKey: string, runId?: string) {
  const path = `/agent-runs/${encodeURIComponent(documentKey)}`

  return runId ? `${path}?${AGENT_RUN_PARAM}=${encodeURIComponent(runId)}` : path
}
